import React from 'react';
import { Row } from 'reactstrap';

const TopBanner = ({ data, Content }) => {
    return (
        <Row>
            <div className="bg-success border-bottom rounded-bottom-4">
                <p className='lassName="d-flex justify-content-center p-3 text-white fs-5 mb-0'>
                    {Content?.topBannerCall}, {data?.memberName ? data?.memberName : null}.
                </p>
                {Content?.topBanner?.map((item, index) => (
                    <>
                        <p className="d-flex justify-content-center p-3 pt-0 text-white fs-5 mb-0">{item?.content}</p>
                    </>
                ))}
            </div>
        </Row>
    );
};

export default TopBanner;
